import * as React from 'react';
import cn from 'clsx';
import { TDeviceType } from '@cian/ui-kit';

import * as styles from './styles.css';

export interface IPageBaseLayout {
  quizCompleted?: boolean;
  deviceType: TDeviceType;
}

export const PageBaseLayout: React.FC<React.PropsWithChildren<IPageBaseLayout>> = props => {
  return (
    <div className={cn(styles['wrapper'], props.quizCompleted && styles['quiz_completed'])}>
      <div className={cn(styles['container'], styles[props.deviceType])}>{props.children}</div>
    </div>
  );
};

PageBaseLayout.displayName = 'PageBaseLayout';
